import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { FormControl } from '@angular/forms'
import { CpmService } from 'app/service/cpm.service'
import { StoreService } from 'app/service/store.service'
import { CrmScreenComponent } from '../crm-screen/crm-screen.component'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Output()
  createButtonClick: EventEmitter<any> = new EventEmitter()
  searchInputControl = new FormControl()
  searchContinueCaseInputControl = new FormControl()
  securityList = []
  searchResults = []
  searchContinueCaseResults = []
  meetingDate = new Date().toISOString().slice(0, 10)
  caseType = new FormControl('N')
  displayCaseSearch = false
  constructor(private cpmService: CpmService, private toastr: ToastrService) {
    this.cpmService.getSecurityList().then(response => {
      this.securityList = response.map(x => x.securitySymbol)
    })
  }

  ngOnInit() {
    this.caseType.valueChanges.subscribe(changeCaseType => {
      if (changeCaseType === 'C') {
        this.displayCaseSearch = true
        this.fetchingSecurityCase()
      } else {
        this.displayCaseSearch = false
      }
    })
    this.searchInputControl.valueChanges.subscribe(changeSearchValue => {
      const upperSymbol = changeSearchValue.toUpperCase()
      const element = this.securityList.find(x => x === upperSymbol)
      if (this.caseType.value === 'C' && element) {
        this.fetchingSecurityCase()
      }
    })
  }

  async fetchingSecurityCase() {
    if (this.searchInputControl.value) {
      await this.cpmService
        .getCrmCase(this.searchInputControl.value, 'securitySymbol')
        .then(response => {
          this.searchContinueCaseResults = response.map(x => x.caseId)
          if (this.searchContinueCaseResults.length > 0) {
            this.searchContinueCaseInputControl.setValue(
              this.searchContinueCaseResults[0]
            )
          }
        })
    }
  }

  onEnter(event) {
    const companySymbol = this.searchInputControl.value.replace(
      /[^a-zA-Z\d\&-\s]+/g,
      ''
    )
    if (companySymbol) {
      const companySymbolUpperCase = companySymbol.toUpperCase()
      this.searchInputControl.setValue(companySymbolUpperCase)
      this.searchResults = this.securityList
        .filter(x => x.startsWith(companySymbolUpperCase))
        .splice(0, 5)
    }
  }

  createClick() {
    const meetingDate = this.meetingDate
    const element = this.securityList.find(
      x => x === this.searchInputControl.value
    )
    if (!element) {
      this.toastr.info('Security symbol not found!')
      return
    }
    this.createButtonClick.emit({
      securitySymbol: this.searchInputControl.value,
      meetingDate: meetingDate,
      caseType: this.caseType.value,
      continueCaseId: this.searchContinueCaseInputControl.value
    })
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/input/input.component.ts